import { NotificationType } from "../../enums/notification-type-enum";
import { BaseModel } from "../base.model";

export class NotificationModel extends BaseModel {
    isRead?: boolean;
    ownerId?: string;
    subject?: string;
    description?: string;
    type?: NotificationType;
}
